import Vue from 'vue'
import App from './App.vue'
import { router } from './router';

Vue.config.productionTip = false

// Nunito, as kortspel
import '@fontsource/nunito/latin-400.css';
import '@fontsource/nunito/latin-600.css';
import '@fontsource/nunito/latin-700.css';
import '@fontsource/nunito/latin-800.css';

import { BootstrapVue } from 'bootstrap-vue'

Vue.use(BootstrapVue)

import plugins from "./helpers/";
Vue.use(plugins);


// SVG inline
import InlineSvg from 'vue-inline-svg';
Vue.component('inline-svg', InlineSvg);

new Vue({
  router,
  //store,
  render: h => h(App)
}).$mount('#app');
